import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
//redux
import { useDispatch, useSelector } from "react-redux"
import { getAboutData } from "../../redux/page/pageActions"
//MUI
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import Paper from "@material-ui/core/Paper"
import { Typography } from "@material-ui/core"
import Collapse from "@material-ui/core/Collapse/Collapse"
import Divider from "@material-ui/core/Divider"
import Skeleton from "@material-ui/lab/Skeleton"
//MUI Icons
import CheckIcon from "@material-ui/icons/Check"
//My Component
import WideLayout from "../../layouts/WideLayout"
import AboutUsCarousel from '../../components/Page/AboutUs/Carousel'
import * as TextLoader from '../../components/StaticTexts/Index'

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
        padding: "10px auto",
    },
    textColorDark: {
        color: "#3B3B3B",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
    },
    grayBoxWithTitle: {
        backgroundColor: "#f2f2f2",
        marginTop: "-5px",
        borderRadius: "10px",
        padding: "45px 40px 40px 40px",
        [theme.breakpoints.down("xs")]: {
            padding: "0",
            margin: '0',
            backgroundColor: "#fff",

        },
    },
    green: {
        color: "#417557",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    lineHeight: {
        lineHeight: "211.6%",
    },
    plus: {
        backgroundColor: "#3B3B3B",
        borderRadius: "50%",
        fontFamily: "tahoma",
        fontWeight: "normal",
        fontSize: "25px",
        height: "20px",
        color: "#fff",
        width: "20px",
        lineHeight: "25.4px",
        textAlign: "center",
    },
    pointer: {
        cursor: "pointer",
    },
    textActive: {
        color: "#EC1F25",
        fontWeight: "bold",
    },
    noP: {
        [theme.breakpoints.down("xs")]: {
            padding: "10px",
            margin: '0',
            marginBottom: '40px'
        },
    }
}));

const AboutUs = ({ lang }) => {

    const [loading, setLoading] = useState(true);
    const classes = useStyles();
    const dispatch = useDispatch();
    const about = useSelector((state) => state.aboutData);
    const { locading, error, aboutText, whySentences, faq, imgs } = about;
    const [staticText, setStaticText] = useState({})

    const [breadcrumbsItems, setBreadcrumbsItems] = useState([]);
    const [item, setItem] = React.useState(1);

    useEffect(() => {

        dispatch(getAboutData(lang)).then(() => setLoading(false));
        if (lang === 'fa') {
            setBreadcrumbsItems([
                {
                    title: 'صفحه اصلی',
                    to: "/"
                },
                {
                    title: 'درباره ما',
                    to: "/aboutUS"
                }
            ])
        }
        else {
            setBreadcrumbsItems([
                {
                    title: 'الصفحة الأصلية',
                    to: "/"
                },
                {
                    title: 'معلومات عنا',
                    to: "/aboutUS"
                }
            ])
        }
        setStaticText(TextLoader.staticTextLoader("aboutUs", lang))

    }, [dispatch]);

    //Active Selected one
    const collapse = (num) => {
        return setItem(num);
    };

    const variants = [
        "h3",
        "h6",
        "body1",
        "caption",
        "caption",
        "caption",
        "caption",
        "caption",
    ];

    return (
        <>
            <WideLayout lang={lang} breadcrumbsItems={breadcrumbsItems} title="درباره ما | آجیل حسن پور" metas={{
                keywords: "پسته ,فندق,آجیل , عید , پاستیل , زعفران , شیرینی , آلوچه ,لواشک ,بادام , مغز ,مغز گردو ,گردو , تخمه , پشمک , شکلات ,ماش ,لوبیا ",
                description: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
                subject: "nuts",
                copyright: 'Ajilhassanpour',
                language: lang,
                robots: "index,follow",
                abstract: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
                topic: 'nuts',
                summary: 'آجیل حسن پور ',
                Classification: 'E-COMMERCE',
                copyright: 'ajilhassanpour.com',
                url: window.location.href,
                directory: 'submission',
                category: 'nuts',
                coverage: 'Worldwide',
                distribution: 'Global',
                'og:title': ' محصولات | آجیل حسن پور ',
                "og:type": 'article',
                "og:url": window.location.href,
                'og:image': 'https://ajilhassanpour.com/images/home-page-header/logo.png',
                'og:site_name': 'آجیل حسن پور',
                'og:description': 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...'
            }}>
                <Grid md={12} sm={12} xs={12}>
                    <Paper elevation={0}>
                        <div className="titleBox">
                            <h1>{staticText.title}</h1>
                        </div>
                        <Box
                            boxShadow={0}
                            border={0}
                            borderRadiusBottomLeft={10}
                            m={1}
                            mb={0}
                            className={classes.grayBoxWithTitle}>
                            <Paper elevation={0}>
                                <Box
                                    elevation={0}
                                    boxShadow={0}
                                    className={classes.noP}
                                    p={2}
                                    py={4}
                                    m={1}
                                    borderRadius={10}>
                                    <Grid container>
                                        <Grid item md={6} sm={12} xs={12}>
                                            <Typography
                                                variant="h6"
                                                className={classes.textColorDark}
                                                style={{ fontWeight: "bold" }}
                                                gutterBottom
                                            >
                                                {staticText.aboutText}
                                            </Typography>
                                            <Box pr={{ xs: 0, sm: 3, md: 4 }}>
                                                {loading ? (
                                                    variants.map((variant) => (
                                                        <Typography
                                                            component="div"
                                                            key={variant}
                                                            variant={variant}
                                                        >
                                                            <Skeleton
                                                                width={Math.random() * (101 - 30) + 30 + "%"}
                                                            />
                                                        </Typography>
                                                    ))
                                                ) : (
                                                    <Typography
                                                        variant="body2"
                                                        className={classes.lineHeight}
                                                        style={{ textAlign: 'justify' }}>
                                                        <div dangerouslySetInnerHTML={{ __html: aboutText }} />
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Grid>

                                        <Grid item md={6} sm={12} xs={12}>
                                            <AboutUsCarousel imgs={imgs} loading={loading} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Paper>
                        </Box>
                        <Box mt={-1} className="titleBox">
                            <h1>{staticText.faqsTitle}</h1>
                        </Box>
                        <Box
                            boxShadow={0}
                            border={0}
                            borderRadiusBottomLeft={10}
                            p={2}
                            pt={1}
                            m={1}
                            className={classes.grayBoxWithTitle}>
                            <Grid container>
                                <Grid item md={6} xs={12}>
                                    <Box
                                        elevation={0}
                                        bgcolor="#fff"
                                        borderRadius={10}
                                        boxShadow={0}
                                        px={2}
                                        py={3}
                                        m={1}
                                        className={classes.noP}

                                    >
                                        {loading &&
                                            variants.map((variant) => (
                                                <Typography
                                                    component="div"
                                                    key={variant}
                                                    variant={variant}
                                                >
                                                    <Skeleton />
                                                </Typography>
                                            ))}
                                        {!loading &&
                                            !error &&
                                            faq.map((sentences, i) => (
                                                <>
                                                    <Box mt={2} pb={2}>
                                                        <a
                                                            onClick={() => collapse(sentences.id)}
                                                            className={
                                                                item === sentences.id ? classes.textActive : ""
                                                            }
                                                        >
                                                            <Grid container>
                                                                <span className={classes.plus}>
                                                                    {item === sentences.id ? "-" : "+"}
                                                                </span>
                                                                    &nbsp;
                                                                    <b className={classes.pointer}>
                                                                    {sentences.question}
                                                                </b>
                                                            </Grid>
                                                        </a>
                                                        <Collapse in={item === sentences.id ? true : false}>
                                                            <Box my={1}>{sentences.answer}</Box>
                                                        </Collapse>
                                                    </Box>
                                                    {sentences.id !== "6" && <Divider />}
                                                </>
                                            ))}
                                    </Box>
                                </Grid>

                                <Grid item md={6} xs={12}>
                                    <Box
                                        elevation={0}
                                        bgcolor="#fff"
                                        borderRadius={10}
                                        boxShadow={0}
                                        p={2}
                                        py={3}
                                        m={1}
                                        className={classes.noP}

                                    >
                                        <Box ml={5}>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                                className={`${classes.green}`}>
                                                <b>{staticText.whyText}</b>
                                            </Typography>
                                        </Box>
                                        {loading &&
                                            variants.map((variant) => (
                                                <Typography
                                                    component="div"
                                                    key={variant}
                                                    variant={variant}
                                                >
                                                    <Skeleton
                                                        width={Math.random() * (100 - 30) + 30 + "%"}
                                                    />
                                                </Typography>
                                            ))}

                                        {!loading &&
                                            !error &&
                                            whySentences.map((items) => (
                                                <Box mt={2}>
                                                    <Typography variant="body1" gutterBottom>
                                                        <span className={`${classes.green}`}>
                                                            {" "}
                                                            <CheckIcon
                                                                style={{ marginBottom: "-10px" }}
                                                                fontSize="large"
                                                            />
                                                        </span>
                                                        <b>{items.sentence}</b>
                                                    </Typography>
                                                </Box>
                                            ))}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
            </WideLayout>
        </>
    );
};

AboutUs.propTypes = {
    lang: PropTypes.string,
};

export default AboutUs